import { render, staticRenderFns } from "./mail-templates-list.vue?vue&type=template&id=a952bff4&scoped=true"
import script from "./mail-templates-list.vue?vue&type=script&lang=js"
export * from "./mail-templates-list.vue?vue&type=script&lang=js"
import style0 from "./mail-templates-list.vue?vue&type=style&index=0&id=a952bff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a952bff4",
  null
  
)

export default component.exports